import { get, map } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CallItemDetailInnerTab defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallItemDetailInnerTabService } from 'services/callItemDetailInnerTab';
 *
 * // create service instance and send/cancel request
 * const callItemDetailInnerTabService = new CallItemDetailInnerTabService();
 * const result = await callItemDetailInnerTabService.fetchData( '<user-id>' ); // fetch data
 * callItemDetailInnerTabService.cancel(); // cancel an active request
 */
export class CallItemDetailInnerTabService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            // extract component data
            const defaultTab = get( response, 'body.component.structure.defaultTabConfig', {} );
            const tabsConfig = get( response, 'body.component.structure.tabsConfig', {} );

            const tabs = map( get( response, 'body.component.data.state.members', [] ), item => (
                {
                    id: item.memberId,
                    patientId: item.patientId,
                    name: tabsConfig.name,
                    url: tabsConfig.url,
                    requestPayload: { memberId: item.memberId,  patientId: item.patientId },
                    title: {
                        refId: '',
                        value: item.name
                    },
                    action: get( item, 'actionsVisibility.view' ) ? tabsConfig.viewAction : null, // view more action
                }
            ) );
           
           return {
               status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
               data: { tabs: [ {...defaultTab, ...tabsConfig}, ...tabs ], }
           };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
